export function transformDataWithSubgroups(incomingData, stateData) {
	const subgroups = [
		...new Set(
			stateData
				? stateData.map(subgroup => subgroup.subGroupName)
				: incomingData.map(subgroup => subgroup.subGroupName)
		),
	];
	return subgroups.map(subgroupName => {
		return {
			subgroup: subgroupName,
			items: stateData
				? stateData.filter(subgroupItem => subgroupItem.subGroupName === subgroupName)
				: incomingData.filter(subgroupItem => subgroupItem.subGroupName === subgroupName),
		};
	});
}

export function formatToSnakeCase(stringValue) {
	return stringValue.replace(/\W+/g, ' ').split(/ |\B(?=[A-Z])/).map(word => word.toLowerCase()).join('_');
}
